import './Help.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'lodash';

import provideTranslations from 'decorators/provideTranslations';
import connectStore from 'decorators/connectStore';
import HelpStore from 'stores/HelpStore';
import I18nStore from 'stores/I18nStore';
import HelpActionCreator from 'actions/HelpActionCreator';
import NavPage from 'components/layout/NavPage';
import ActivitySpinner from 'components/shared/ActivitySpinner';
import HelpDesktop from 'components/help/HelpDesktop';
import HelpMobile from 'components/help/HelpMobile';
import DeviceUtils from 'utils/DeviceUtils';

@provideTranslations('help')
@connectStore(HelpStore, 'helpState')
class HelpContainer extends React.Component {
  render() {
    return (
      <Help {...this.props} />
    );
  }
}

class Help extends React.Component {
  static propTypes = {
    helpState: PropTypes.object.isRequired,
    params: PropTypes.object,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static constants = {
    INTRO_HELP_PAGE_NODE_ID: 'G7MPLUQ72CHVZCBV',
  };

  constructor(props) {
    super(props);

    this.state = {};
    this.pageRef = React.createRef();

    this.handleContextRef = this.handleContextRef.bind(this);
  }

  componentDidMount() {
    HelpActionCreator.getHelp(
      defaultTo(this.props.params.nodeId, Help.constants.INTRO_HELP_PAGE_NODE_ID),
      { locale: I18nStore.getState().currentLocale },
    );
  }

  componentWillReceiveProps(nextProps) {
    const { getString } = this.context;
    if (nextProps.helpState.error) {
      this.pageRef.current.showFailed(
        getString('AA_Something_Went_Wrong'),
        this.handleFailed,
        getString('AA_Retry'),
      );
    }
  }

  handleContextRef(contextRef) {
    this.setState({ contextRef });
  }

  handleFailed() {
    window.location.reload();
  }

  renderDesktop() {
    return (
      <HelpDesktop
        contextRef={this.state.contextRef}
        helpState={this.props.helpState}
        selectedNodeId={this.props.params.nodeId}
      />
    );
  }

  renderMobile() {
    return (
      <HelpMobile
        contextRef={this.state.contextRef}
        helpState={this.props.helpState}
        selectedNodeId={this.props.params.nodeId}
      />
    );
  }

  renderSpinner() {
    return <ActivitySpinner className="absolute-center" />;
  }

  renderContent() {
    return (
      <div className="aa-help-container container" ref={this.handleContextRef}>
        { DeviceUtils.isDesktop() ? this.renderDesktop() : this.renderMobile() }
      </div>
    );
  }

  render() {
    const content = !this.props.helpState.isLoaded ? this.renderSpinner() : this.renderContent();

    return (
      <NavPage ref={this.pageRef}>
        { content }
      </NavPage>
    );
  }
}

export default HelpContainer;
